/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_LoadingInputs */

const en_settings_profile_loading = /** @type {(inputs: Settings_Profile_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading...`)
};

const zh_settings_profile_loading = /** @type {(inputs: Settings_Profile_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载中...`)
};

/**
* | output |
* | --- |
* | "Loading..." |
*
* @param {Settings_Profile_LoadingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_profile_loading = /** @type {((inputs?: Settings_Profile_LoadingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_LoadingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_loading(inputs)
	return zh_settings_profile_loading(inputs)
});
export { settings_profile_loading as "settings.profile.loading" }